// hooks/useWarning.ts
import { message } from "antd";

export const useWarning = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const showWarning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
      key: "warning",
      duration: 5,
    });
  };

  return { showWarning, contextHolder };
};
